
import { Component, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { consultorioService } from '../../services/ConsultorioService';

@Component({
  name: "CrearCita",
})

export default class CrearCita extends Vue {
  private consultorioStore = useConsultorioStore();
  private consultorioService = consultorioService.getInstance();
  private tab: any = null;
  public dialog = false;
  public codigo = '';
  public cuenta = '';
  public numero = '';
  cliente_seleccionado = '';
  pacientes_all = [];
  public paciente = {
    codigo: '',
    cuenta: '',
    nombre: '',
    direccion: '',
    nit: '',
    telefono: '',
    placa: '',
    periodo: ''
  };
  cita = {
    paciente: '',
    paciente_ci: '',
    paciente_id: null,
    tratamiento_id: '',
    fecha: DateTime.now().toFormat("yyyy-MM-dd"),
    hora: DateTime.now().toFormat("HH:mm"),
    motivo: '',
    antecedentes: '',
    observaciones: '',
    gestaciones: '',
    partos: '',
    abortos: '',
    cesareas: '',
    fecha_ultima_menstruacion: '',
    oroscopia: '',
    rinoscopia: '',
    otoscopia: '',
    examenes_complementarios: '',
    diagnostico: '',
    nota: '',
    costo: 0,
    convenio_id: null,
    tratamiento: ''


  }
  tratamientoSelected:any = null;
  swEditar = true;
  valid = true;
  fecha = DateTime.now().toFormat('yyyy-MM-dd');
  edad = '-';

  get pacientes(): any {
    return this.consultorioStore.pacientes;
  }
  get tratamientos(): any {
    return this.consultorioStore.tratamientos;
  }
  txtSearch = "";
  selected_paciente = {};
  mounted() {
    this.getTratamientos();
  }


  closePaciente() {
    this.dialog = false;
  }
  newPaciente() {
    this.dialog = true;
  }
  asignarPaciente(paciente: any) {
    this.paciente = paciente;
  }
  getPacientesSearch(value: string) {
    this.loading
    this.consultorioService.getPacientesSearch(value).then(res => {
      console.log(res);
      //this.pacientes_all = res;
    })
  }
  getTratamientos() {
    this.consultorioService.getTratamientos()
  }
  actualizarCostoTratamiento() {
    this.cita.tratamiento_id = this.tratamientoSelected.id;
    if(this.cita.convenio_id != null) {
      this.cita.costo = 0;
      return;
    }
    if (this.cita.tratamiento_id) {
      this.cita.costo = this.tratamientoSelected.costo;
    } else {
      this.cita.costo = 0;
    }
  }
  guardar() {
    if (!this.$refs.form.validate()) {
      Alert.warning(`Lene todos los campos obligatorios (*)`)
      return;
    }
    if (this.swEditar) {
      Alert.confirm(`Se realizará el registro de la consulta del paciente ${this.cita.paciente}`, 'Registrar nueva Consulta?').then(async result => {
        if (result.isConfirmed) {
          await this.consultorioService.registrarCita(this.cita).then(response => {

            this.limpiar()
            this.$router.push({ name: 'citas-medicas' });
          })

        }
      })
    } else {
      Alert.confirm(`Se realizará la modificacion de la venta`, 'Modificar venta?').then(async result => {
        if (result.isConfirmed) {
          await this.consultorioService.editarVenta(this.venta)
          this.limpiar()
        }
      })
    }

  }
  seleccionCliente() {
    console.log(this.selected_paciente)
    if (this.paciente !== null) {
      this.cita.paciente = this.selected_paciente.nombre_completo;
      this.cita.paciente_ci = this.selected_paciente.ci;
      this.cita.paciente_id = this.selected_paciente.id;
      this.cita.convenio_id = this.selected_paciente.convenio_id;
      this.edad = this.selected_paciente.fecha_nacimiento != null? Number(DateTime.now().diff(DateTime.fromISO(this.selected_paciente.fecha_nacimiento), 'years').toObject().years).toFixed(0): '';
    } else
      this.limpiar()

  }
  
  limpiar() {
    this.cita = {
      paciente: '',
      paciente_ci: '',
      paciente_id: null,
      tratamiento_id: '',
      fecha: DateTime.now().toFormat("yyyy-MM-dd"),
      hora: DateTime.now().toFormat("HH:mm"),
      motivo: '',
      observaciones: '',
      convenio_id: null,
    }
  }
  get loading(): boolean {
    return this.consultorioStore.loading;
  }
  get convenios(): any {
		return this.consultorioStore.convenios;
	}
  @Watch('txtSearch')
  search(value: string) {
    console.log(value);
    if (value != null && value.length > 2) {
      this.$nextTick().then(() => {
        this.getPacientesSearch(value);
      })

      this.pacientes_all = this.consultorioStore.pacientes;
      console.log(this.pacientes_all);
    }



  }
}

